import React from 'react';
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import css from "./SemiFinishedSemiFinishedListModal.module.css";
import SemiFinishedSemiFinishModal from "../SemiFinishedSemiFinishModal/SemiFinishedSemiFinishModal";


const SemiFinishedSemiFinishedListModal = () => {
    const {t} = useTranslation();
    const {semiFinishedSemiFinishedForModalArray} = useSelector(store => store.semiFinishedSemiFinished);



    return (
        <div className={css.wrap}>
            {semiFinishedSemiFinishedForModalArray.length > 0 ? (
                semiFinishedSemiFinishedForModalArray.map((obj, index) => <SemiFinishedSemiFinishModal
                    key={obj.id}
                    data={obj}
                    index={index}
                />)
            ) : <div className={css.noData}>{t('no-data')}</div>}
        </div>
    );
};

export default React.memo(SemiFinishedSemiFinishedListModal);